import { ApolloError, useQuery } from '@apollo/client';

import {
  GetStandardDeliveryDeviceHigherCategoryReportQuery,
  GetStandardDeliveryDeviceHigherCategoryReportQueryVariables,
  StandardDeliveryDeviceHigherCategoryReport,
} from '../../types';
import { GET_STANDARD_DELIVERY_DHC_REPORT } from './getStandardDeliveryDHCReport';

type StandardDeliveryDHCReportResponse = {
  data?: StandardDeliveryDeviceHigherCategoryReport;
  loading: boolean;
  error?: ApolloError;
};

const useStandardDeliveryDHCReport = (id: string): StandardDeliveryDHCReportResponse => {
  const { data, loading, error } = useQuery<
    GetStandardDeliveryDeviceHigherCategoryReportQuery,
    GetStandardDeliveryDeviceHigherCategoryReportQueryVariables
  >(GET_STANDARD_DELIVERY_DHC_REPORT, {
    variables: {
      id,
    },
  });

  return {
    loading,
    error,
    data: data?.getStandardDeliveryDeviceHigherCategoryReport,
  };
};

export default useStandardDeliveryDHCReport;
